const lightColor = {
  actionPrimaryInitial: '#0072F1',
  iconPositiveInitial: '#02791D',
  iconNegativeInitial: '#C74040',
  iconNeutralSoft: '#D1D5D6',
  iconNeutralMedium: '#8E9699',
  surfaceCanvasPrimaryInitial: '#F7F7F7', //neutral100
  textNeutralStrong: '#242631',
  surfaceCanvasSecondaryInitial: '#ffffff',
  strokeNeutralSoftInitial: '#d7d8da',
  labelPrimary: '#242631',
}

const darkColor = {
  actionPrimaryInitial: '#0046E1',
  iconPositiveInitial: '#419A56',
  iconNegativeInitial: '#B50000',
  iconNeutralSoft: '#BCC1C2',
  iconNeutralMedium: '#D1D5D6',
  surfaceCanvasPrimaryInitial: '#202124', // neutral900
  textNeutralStrong: '#FFFFFF',
  surfaceCanvasSecondaryInitial: '#303341',
  strokeNeutralSoftInitial: '#595b67',
  labelPrimary: '#242631',
  labelBackground: '#FFFFFF',
}

export const BIT2ME_TRADING_VIEW_COLORS = {
  light: {
    backgroundColor: lightColor.surfaceCanvasPrimaryInitial,
    barDownColor: lightColor.iconNegativeInitial,
    barUpColor: lightColor.iconPositiveInitial,
    color: lightColor.actionPrimaryInitial,
    textColor: lightColor.textNeutralStrong,
    volumeBarColor: lightColor.iconNeutralSoft,
    crossHairColor: lightColor.iconNeutralMedium,
    crossHairBgColor: lightColor.iconNeutralSoft,
  },
  dark: {
    backgroundColor: darkColor.surfaceCanvasPrimaryInitial,
    barDownColor: darkColor.iconNegativeInitial,
    barUpColor: darkColor.iconPositiveInitial,
    color: darkColor.actionPrimaryInitial,
    textColor: darkColor.textNeutralStrong,
    volumeBarColor: darkColor.iconNeutralSoft,
    crossHairColor: darkColor.iconNeutralMedium,
    crossHairBgColor: darkColor.iconNeutralSoft,
  },
}

export const BIT2ME_TRADING_VIEW_SIMPLE_CHART_COLORS = {
  light: {
    actionDefault: lightColor.actionPrimaryInitial,
    backgroundPrimary: lightColor.surfaceCanvasPrimaryInitial,
    backgroundSecondary: lightColor.surfaceCanvasSecondaryInitial,
    strokeNeutralSoftInitial: lightColor.strokeNeutralSoftInitial,
    positive: lightColor.iconPositiveInitial,
    negative: lightColor.iconNegativeInitial,
    labelPrimary: lightColor.labelPrimary,
  },
  dark: {
    actionDefault: darkColor.actionPrimaryInitial,
    backgroundPrimary: darkColor.surfaceCanvasPrimaryInitial,
    backgroundSecondary: darkColor.surfaceCanvasSecondaryInitial,
    strokeNeutralSoftInitial: darkColor.strokeNeutralSoftInitial,
    positive: darkColor.iconPositiveInitial,
    negative: darkColor.iconNegativeInitial,
    labelPrimary: darkColor.labelPrimary,
    labelBackground: darkColor.labelBackground,
  },
}
